import React from 'react';
import { XIcon } from 'lucide-react';
interface CookiesModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CookiesModal({
  isOpen,
  onClose
}: CookiesModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4 backdrop-blur-sm" data-id="element-18">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-19">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between" data-id="element-20">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-21">
            Política de Cookies
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-50 rounded-lg" data-id="element-22">
            <XIcon className="h-5 w-5" data-id="element-23" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 space-y-5 text-sm text-gray-600 leading-relaxed" data-id="element-24">
          <div className="text-center mb-6" data-id="element-25">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-26">
              Política de Cookies de ClubAhorra, Benefika y TicketMaestro
            </h3>
          </div>

          <section data-id="element-27">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-28">1. INTRODUCCIÓN</h4>
            <p data-id="element-29">
              En ClubAhorra, Benefika y TicketMaestro, utilizamos cookies y
              tecnologías similares para mejorar la experiencia de navegación en
              nuestros sitios web, analizar el tráfico, personalizar el
              contenido y mostrar anuncios relevantes. A continuación, te
              explicamos qué son las cookies, cómo las usamos y cómo puedes
              gestionarlas.
            </p>
          </section>

          <section data-id="element-30">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-31">
              2. ¿QUÉ SON LAS COOKIES?
            </h4>
            <p data-id="element-32">
              Las cookies son pequeños archivos de texto que un sitio web
              almacena en tu dispositivo (computadora, celular o tablet) al
              visitarlo. Estas permiten que el sitio "recuerde" tus acciones o
              preferencias (como idioma, inicio de sesión, etc.) durante un
              período de tiempo determinado.
            </p>
          </section>

          <section data-id="element-33">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-34">
              3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
            </h4>

            <div className="space-y-3 mt-3" data-id="element-35">
              <div data-id="element-36">
                <p className="font-semibold text-gray-800" data-id="element-37">
                  A. Cookies necesarias (técnicas):
                </p>
                <p data-id="element-38">
                  Permiten la navegación en el sitio web y el uso de sus
                  funciones esenciales. Sin estas cookies, el sitio no puede
                  funcionar correctamente.
                </p>
              </div>

              <div data-id="element-39">
                <p className="font-semibold text-gray-800" data-id="element-40">
                  B. Cookies de preferencia o personalización:
                </p>
                <p data-id="element-41">
                  Almacenan información para que el usuario acceda al servicio
                  con características personalizadas, como el idioma o región.
                </p>
              </div>

              <div data-id="element-42">
                <p className="font-semibold text-gray-800" data-id="element-43">
                  C. Cookies de análisis o rendimiento:
                </p>
                <p data-id="element-44">
                  Nos permiten conocer el comportamiento de los visitantes para
                  mejorar el sitio. Usamos herramientas como Google Analytics u
                  otras similares.
                </p>
              </div>

              <div data-id="element-45">
                <p className="font-semibold text-gray-800" data-id="element-46">
                  D. Cookies de publicidad o marketing:
                </p>
                <p data-id="element-47">
                  Recopilan información sobre tus hábitos de navegación para
                  mostrarte anuncios relevantes en nuestros sitios o en otros.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-48">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-49">
              4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
            </h4>
            <ul className="list-disc pl-5 space-y-1" data-id="element-50">
              <li data-id="element-51">
                <strong data-id="element-52">Cookies de sesión:</strong> se eliminan al cerrar el
                navegador.
              </li>
              <li data-id="element-53">
                <strong data-id="element-54">Cookies persistentes:</strong> permanecen en tu
                dispositivo hasta que las elimines o expiren.
              </li>
            </ul>
          </section>

          <section data-id="element-55">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-56">
              5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
            </h4>
            <p className="mb-3" data-id="element-57">
              Al ingresar por primera vez a nuestro sitio, se te mostrará un
              aviso de cookies. Puedes aceptar todas, rechazarlas o
              configurarlas según tu preferencia.
            </p>
            <p className="mb-2" data-id="element-58">
              Además, puedes modificar la configuración de cookies desde tu
              navegador en cualquier momento:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-59">
              <li data-id="element-60">
                <strong data-id="element-61">Google Chrome:</strong> Configuración de cookies
              </li>
              <li data-id="element-62">
                <strong data-id="element-63">Mozilla Firefox:</strong> Administrar cookies
              </li>
              <li data-id="element-64">
                <strong data-id="element-65">Safari:</strong> Soporte de Safari
              </li>
              <li data-id="element-66">
                <strong data-id="element-67">Microsoft Edge:</strong> Privacidad y servicios
              </li>
            </ul>
          </section>

          <section data-id="element-68">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-69">
              6. COOKIES DE TERCEROS
            </h4>
            <p className="mb-2" data-id="element-70">
              Algunas cookies pueden ser instaladas por servicios de terceros
              utilizados en nuestro sitio (como redes sociales, plataformas de
              video, servicios de estadísticas, etc.). No tenemos control
              directo sobre ellas. Te recomendamos revisar sus respectivas
              políticas:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-71">
              <li data-id="element-72">
                <strong data-id="element-73">Google:</strong> Política de privacidad
              </li>
              <li data-id="element-74">
                <strong data-id="element-75">Meta (Facebook / Instagram):</strong> Política de
                cookies
              </li>
            </ul>
          </section>

          <section data-id="element-76">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-77">
              7. CAMBIOS EN ESTA POLÍTICA
            </h4>
            <p data-id="element-78">
              Podemos actualizar esta Política de Cookies en cualquier momento.
              Te notificaremos en nuestro sitio web cuando se hagan cambios
              relevantes.
            </p>
          </section>

          <section data-id="element-79">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-80">8. CONTACTO</h4>
            <p data-id="element-81">
              Si tienes dudas sobre nuestra política de cookies, puedes
              escribirnos a:{' '}
              <span className="font-medium text-brand-600" data-id="element-82">
                contacto@benefica.net
              </span>
            </p>
          </section>

          <section data-id="element-83">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-84">9. VIGENCIA</h4>
            <p data-id="element-85">
              La vigencia de estas Políticas es desde el 21 de noviembre de 2025
              y permanecerá vigente hasta que exista una nueva versión que la
              reemplace.
            </p>
          </section>

          <div className="pt-4 border-t border-gray-200 text-xs text-gray-500" data-id="element-86">
            Última actualización: 21 de noviembre de 2025
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-100 px-6 py-4 bg-gray-50" data-id="element-87">
          <button onClick={onClose} className="w-full bg-brand-600 text-white py-3 rounded-lg font-semibold hover:bg-brand-700 transition-colors" data-id="element-88">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}